import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {CabecalhoComponent} from './cabecalho/cabecalho.component';
import {TabelaConsultaComponent} from './tabela-consulta/tabela-consulta.component';
import {ProcedimentosComponent} from './procedimentos/procedimentos.component';
import {EvolucaoComponent} from './evolucao/evolucao.component';
import {PrescricaoComponent} from './prescricao/prescricao.component';
import {ExamesComponent} from './exames/exames.component';
import {AgendaComponent} from './agenda/agenda.component';
import {EncaminhamentoComponent} from './encaminhamento/encaminhamento.component';
import {AtestadosComponent} from './atestados/atestados.component';
import {ProntuariosAvulsosComponent} from './prontuarios-avulsos/prontuarios-avulsos.component';
import {ChatComponent} from './chat/chat.component';
import {LoadingComponent} from './loading/loading.component';
import {NgxSpinnerModule} from "ngx-spinner";
import {NumeroParaHoraPipe} from '../pipes/numero-para-hora.pipe';
import {ReticenciasPipe} from '../pipes/reticencias.pipe';
import {IdadePipe} from "../pipes/idade.pipe";
import {FormsModule} from "@angular/forms";
import {ContenteditableModelDirective} from "../directives/contenteditable-model.directive";
import {BooleanPipe} from "../pipes/boolean.pipe";
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [
    CabecalhoComponent,
    TabelaConsultaComponent,
    ProcedimentosComponent,
    EvolucaoComponent,
    PrescricaoComponent,
    ExamesComponent,
    AgendaComponent,
    EncaminhamentoComponent,
    AtestadosComponent,
    ProntuariosAvulsosComponent,
    ChatComponent,
    LoadingComponent,
    NumeroParaHoraPipe,
    IdadePipe,
    ReticenciasPipe,
    BooleanPipe,
    ContenteditableModelDirective,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    NgOptimizedImage,
    NgSelectModule
  ],
  exports: [
    CabecalhoComponent,
    TabelaConsultaComponent,
    ProcedimentosComponent,
    EvolucaoComponent,
    PrescricaoComponent,
    ExamesComponent,
    AgendaComponent,
    EncaminhamentoComponent,
    AtestadosComponent,
    ProntuariosAvulsosComponent,
    ChatComponent,
    LoadingComponent,
    NumeroParaHoraPipe,
    IdadePipe,
    ReticenciasPipe,
  ]
})
export class ComponentesModule {
}
